import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import NewsletterForm from '@/components/base/NewsletterForm';
import { siteInfo } from '@/mocks/articles';

export default function AboutPage() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '吃瓜官网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '吃瓜官网是全网核心的吃瓜资讯入口平台，覆盖51吃瓜官网、黑料吃瓜官网等热门站点，每日推送独家大瓜与网红翻车现场实时追踪，所有内容免费提供。',
        },
      },
      {
        '@type': 'Question',
        name: '吃瓜官网的内容多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的编辑团队全天候追踪热点事件，每日至少更新10篇以上独家内容，确保你不错过任何一个大瓜。重大爆料事件发生后，我们会在30分钟内发布第一手报道。',
        },
      },
      {
        '@type': 'Question',
        name: '如何订阅吃瓜官网的每日简报？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以在网站底部的订阅区域输入邮箱地址，我们将每日为你推送最新的大瓜汇总和独家爆料内容。订阅完全免费，我们承诺不发送任何垃圾邮件。',
        },
      },
      {
        '@type': 'Question',
        name: '吃瓜官网的内容来源可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们拥有专业的调查记者团队和广泛的行业人脉，所有内容均经过多方求证后才发布。对于无法100%确认的信息，我们会明确标注"据传"或"疑似"等字样，确保读者能够区分事实和传闻。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系吃瓜官网提供爆料线索？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过邮箱contact@dollydiy.cn向我们提供爆料线索。我们郑重承诺对所有爆料人信息进行严格保密，绝不透露来源。对于重大的独家爆料，我们还会提供丰厚的线索奖励。',
        },
      },
    ],
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于吃瓜官网',
    description: siteInfo.description,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="mx-auto px-4 md:px-6 max-w-4xl">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            <section className="py-8 md:py-10">
              <div className="text-center mb-12">
                <div className="w-16 h-16 mx-auto flex items-center justify-center mb-4 rounded-full bg-primary-100">
                  <i className="ri-fire-line text-3xl text-primary-500"></i>
                </div>
                <h1 className="font-heading font-black text-2xl md:text-4xl text-foreground-900 mb-3">
                  关于吃瓜官网
                </h1>
                <p className="text-foreground-500 text-base max-w-xl mx-auto">
                  {siteInfo.slogan}
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-14">
                <div>
                  <h2 className="font-heading font-bold text-lg text-foreground-900 mb-3">品牌故事</h2>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                    吃瓜官网成立于{siteInfo.founded}年，由一群热爱八卦、追求真相的资深媒体人联合创办。我们的使命是打造全网最专业、最及时、最全面的吃瓜资讯平台，让每一个热爱吃瓜的人都能在这里找到最新鲜、最劲爆的内容。
                  </p>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                    在信息爆炸的时代，真假难辨的爆料充斥着互联网。吃瓜官网坚持"求真、求快、求全"的原则，组建了一支专业的调查记者团队，深入挖掘每一个热点事件背后的真相。
                  </p>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    从网红翻车到明星八卦，从MCN内幕到直播带货的黑幕，我们始终站在吃瓜第一线，为你带来最独家的爆料和最深入的分析。
                  </p>
                </div>
                <div>
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20journalists%20working%20at%20desks%20with%20multiple%20monitors%20displaying%20breaking%20news%2C%20warm%20lighting%2C%20professional%20editorial%20environment%2C%20dynamic%20atmosphere%2C%20clean%20editorial%20photography%20style&width=800&height=500&seq=chigua-about-story&orientation=landscape"
                    alt="吃瓜官网编辑团队"
                    title="吃瓜官网 - 专业编辑团队"
                    className="rounded-lg w-full h-64 object-cover object-top"
                  />
                </div>
              </div>
            </section>

            <section className="py-8 border-t border-background-200/70">
              <h2 className="font-heading font-bold text-lg text-foreground-900 mb-6 text-center">我们的优势</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-14">
                {[
                  { icon: 'ri-flashlight-line', title: '极速追踪', desc: '重大事件30分钟内发布第一手报道，全天候追踪热点动态' },
                  { icon: 'ri-shield-check-line', title: '多方求证', desc: '每一条爆料均经过多个信源交叉验证，确保内容真实可靠' },
                  { icon: 'ri-group-line', title: '深度人脉', desc: '覆盖娱乐圈、网红圈、MCN行业的广泛人脉网络，独家消息源源不断' },
                ].map((item, i) => (
                  <div key={i} className="bg-background-100/70 rounded-lg p-5 text-center">
                    <div className="w-12 h-12 mx-auto flex items-center justify-center mb-3 rounded-full bg-primary-100">
                      <i className={`${item.icon} text-primary-600 text-xl`}></i>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2">{item.title}</h3>
                    <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="py-8 border-t border-background-200/70">
              <h2 className="font-heading font-bold text-lg text-foreground-900 mb-6 text-center">用户口碑</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-14">
                {[
                  { name: '吃瓜群众小王', rating: 5, comment: '自从发现了吃瓜官网，每天第一件事就是打开看看今天有什么新瓜！内容质量真的高，很多独家爆料在其他地方根本看不到。' },
                  { name: '八卦小能手', rating: 5, comment: '吃瓜官网的更新速度真的绝了！每次有大事件发生，这里总是最先出报道的。而且分析特别到位，不是那种标题党。' },
                  { name: '娱乐观察员', rating: 5, comment: '关注吃瓜官网已经一年多了，真心推荐！不仅内容全面，而且对爆料来源的把控很严格，不会为了流量乱发未经证实的消息。' },
                ].map((review, i) => (
                  <div key={i} className="bg-background-100/70 rounded-lg p-5">
                    <div className="flex items-center gap-1 mb-2">
                      {Array.from({ length: review.rating }).map((_, j) => (
                        <div key={j} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-yellow-500 text-sm"></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-foreground-600 text-sm leading-relaxed mb-3">&ldquo;{review.comment}&rdquo;</p>
                    <p className="text-foreground-400 text-xs font-medium">—— {review.name}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="py-8 border-t border-background-200/70">
              <h2 className="font-heading font-bold text-lg text-foreground-900 mb-6 text-center">联系我们</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-14">
                <div className="bg-background-100/70 rounded-lg p-5 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center mb-3 rounded-full bg-primary-100">
                    <i className="ri-mail-line text-primary-600 text-xl"></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">爆料邮箱</h3>
                  <p className="text-foreground-500 text-xs">{siteInfo.email}</p>
                </div>
                <div className="bg-background-100/70 rounded-lg p-5 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center mb-3 rounded-full bg-primary-100">
                    <i className="ri-wechat-line text-primary-600 text-xl"></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">微信公众号</h3>
                  <p className="text-foreground-500 text-xs">{siteInfo.socialLinks.wechat}</p>
                </div>
                <div className="bg-background-100/70 rounded-lg p-5 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center mb-3 rounded-full bg-primary-100">
                    <i className="ri-tiktok-line text-primary-600 text-xl"></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1">抖音账号</h3>
                  <p className="text-foreground-500 text-xs">{siteInfo.socialLinks.douyin}</p>
                </div>
              </div>

              <div className="bg-background-100/70 rounded-lg p-5 md:p-7 max-w-2xl mx-auto text-center">
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">爆料线索征集</h3>
                <p className="text-foreground-500 text-sm mb-4">
                  你有独家爆料想要分享？我们欢迎所有真实、有价值的线索。你的身份将被严格保密。
                </p>
                <p className="text-foreground-400 text-xs">
                  请将爆料内容发送至：<strong className="text-primary-600">{siteInfo.email}</strong>
                </p>
              </div>
            </section>

            <section className="py-8 border-t border-background-200/70 mb-10">
              <h2 className="font-heading font-bold text-lg text-foreground-900 mb-6 text-center">常见问题</h2>
              <div className="max-w-2xl mx-auto space-y-3">
                {[
                  { q: '吃瓜官网是什么？', a: '吃瓜官网是全网核心的吃瓜资讯入口平台，覆盖51吃瓜官网、黑料吃瓜官网等热门站点，每日推送独家大瓜与网红翻车现场实时追踪，所有内容免费提供。' },
                  { q: '吃瓜官网的内容多久更新一次？', a: '我们的编辑团队全天候追踪热点事件，每日至少更新10篇以上独家内容。重大爆料事件发生后，我们会在30分钟内发布第一手报道。' },
                  { q: '如何订阅吃瓜官网的每日简报？', a: '你可以在网站底部的订阅区域输入邮箱地址，我们将每日为你推送最新的大瓜汇总。订阅完全免费，绝不发送垃圾邮件。' },
                  { q: '吃瓜官网的内容来源可靠吗？', a: '我们拥有专业的调查记者团队和广泛的行业人脉，所有内容均经过多方求证后才发布。对于无法100%确认的信息，会明确标注。' },
                  { q: '如何提供爆料线索？', a: '通过邮箱contact@dollydiy.cn提供线索。我们郑重承诺对所有爆料人信息严格保密，重大独家爆料还会提供丰厚线索奖励。' },
                ].map((faq, i) => (
                  <details key={i} className="group bg-background-100/70 rounded-lg overflow-hidden">
                    <summary className="flex items-center justify-between px-5 py-3.5 cursor-pointer hover:bg-background-200/50 transition-colors">
                      <span className="font-heading font-semibold text-foreground-900 text-sm">{faq.q}</span>
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:hidden"></i>
                        <i className="ri-arrow-up-s-line text-foreground-400 hidden group-open:block"></i>
                      </div>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>
          </div>

          <NewsletterForm />
        </main>

        <Footer />
      </div>
    </>
  );
}